import { defaultTo } from 'ramda';

import { defaultState } from './defaultState';
import { TActions } from '../../../types/actions';
import {
  CHANGE_PROMOTION_SERVICE,
  LOAD_PUBLISH_TERMS_FAIL,
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PACKAGE,
  SELECT_PLACING_PERIOD,
  SELECT_PLACING_TYPE,
  SELECT_PUBLISH_TERMS_SERVICE,
  SET_IS_SERVICES_ENABLED,
  SET_IS_WITHOUT_MINIMAL_BET,
  SET_PLACING_MONEY_SOURCE,
} from './actions';
import { IPublishTermsState, EPublishTermsStatus, IPublishTerms } from './types';
import { mergePublishTerms, syncPeriodId } from './utils';

export function publishTerms(state: IPublishTermsState = defaultState, action: TActions): IPublishTermsState {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      let publishTerms: IPublishTerms;

      if (action.payload.replace) {
        publishTerms = action.payload.publishTerms;
      } else {
        // сохраняем предыдущее состояние
        publishTerms = mergePublishTerms({
          prevTerms: state,
          nextTerms: action.payload.publishTerms,
        });
      }

      return {
        ...state,
        ...publishTerms,
        status: EPublishTermsStatus.success,
        withoutMinimalBet: action.payload.withoutMinimalBet,
        isServicesEnabled: !action.payload.withoutPromotion,
        moneySource: action.payload.moneySource,
        publicationTokens: defaultTo(null, action.payload.publicationTokens),
      };
    }

    case LOAD_PUBLISH_TERMS_FAIL: {
      return {
        ...state,
        status: EPublishTermsStatus.fail,
        error: action.payload || null,
      };
    }

    case SELECT_PUBLISH_TERMS_SERVICE: {
      const { selectedPeriodId, periodsByService } = state;
      const periodsInfo = periodsByService[action.payload];
      const syncedPeriodId = periodsInfo ? syncPeriodId({ selectedPeriodId, ...periodsInfo }) : null;

      return {
        ...state,
        selectedPeriodId: syncedPeriodId,
        selectedServiceId: action.payload,
      };
    }

    case SELECT_PLACING_TYPE: {
      return {
        ...state,
        selectedPlacingType: action.payload,
      };
    }

    case SELECT_PACKAGE: {
      return {
        ...state,
        selectedPackageId: action.payload,
      };
    }

    case SELECT_PLACING_PERIOD: {
      return {
        ...state,
        selectedPeriodId: action.payload,
      };
    }

    case CHANGE_PROMOTION_SERVICE: {
      return {
        ...state,
        promotionServiceId: action.payload,
      };
    }

    case SET_IS_SERVICES_ENABLED: {
      return {
        ...state,
        isServicesEnabled: action.payload,
      };
    }

    case SET_IS_WITHOUT_MINIMAL_BET: {
      return {
        ...state,
        withoutMinimalBet: action.payload,
      };
    }

    case SET_PLACING_MONEY_SOURCE: {
      return {
        ...state,
        moneySource: action.payload,
      };
    }

    default:
      return state;
  }
}
